import {
  BaseEdge,
  getBezierPath,
  useReactFlow,
  EdgeProps,
  useStore,
  EdgeLabelRenderer,
} from "@xyflow/react";
import { AiFillCloseCircle } from "react-icons/ai";
import { BlocksType } from "./types";
import { AnimatedPath } from "./AnimatedPath";

export default function PremiumAnimatedEdge(props: EdgeProps) {
  const { id, source, target, sourceX, sourceY, targetX, targetY, markerEnd } =
    props;

  const { getNode, deleteElements } = useReactFlow();

  const sourceNode = getNode(source);
  const targetNode = getNode(target);

  const sourceNodeIsAction = sourceNode?.data?.type === BlocksType.ACTION;
  const targetNodeIsAction = targetNode?.data?.type === BlocksType.ACTION;

  const pairBlockAncestor = useStore((state) => {
    const findAncestor = (nodeId: string, visited = new Set<string>()): any => {
      if (visited.has(nodeId)) return null;
      visited.add(nodeId);

      const node = state.nodes.find((n) => n.id === nodeId);
      if (!node || node.data?.type === BlocksType.ACTION) return null;
      if (node.data?.type === BlocksType.PAIR_BLOCK) return node;

      const incomingEdges = state.edges.filter((e) => e.target === nodeId);
      for (const edge of incomingEdges) {
        const ancestor = findAncestor(edge.source, visited);
        if (ancestor) return ancestor;
      }
      return null;
    };

    return findAncestor(source);
  });

  const isActive =
    sourceNodeIsAction || targetNodeIsAction ? false : !!pairBlockAncestor;

  const accentColour =
    (pairBlockAncestor?.data?.color as string) ||
    sourceNode?.data?.color ||
    "hsl(240, 99%, 78%)";

  const [path, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition: props.sourcePosition,
    targetPosition: props.targetPosition,
  });
  const onEdgeClick = () => {
    deleteElements({ edges: [{ id: id }] });
  };
  return (
    <>
      {/* 🧱 Base edge */}
      <BaseEdge
        id={id}
        path={path}
        markerEnd={markerEnd}
        style={{
          stroke: "#334155",
          strokeWidth: 3,
          strokeDasharray: isActive ? 0 : 4,
        }}
      />

      {isActive && (
        <>
          <AnimatedPath
            path={path}
            duration={3}
            color={accentColour as string}
          />
        </>
      )}

      <EdgeLabelRenderer>
        <AiFillCloseCircle
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
          }}
          className="nodrag nopan cursor-pointer"
          onClick={onEdgeClick}
        />
      </EdgeLabelRenderer>
    </>
  );
}
